import { c as _c } from "react-compiler-runtime";
import { StyledTable } from './StyledTableComponents';
import { useColumnCallToAction } from '../columnCallToAction/ColumnCallToActionContext';
import { getColumnCallToActionStyles } from '../columnCallToAction/columnCallToActionStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultTableComponent = t0 => {
  var _callToAction$columnI, _styles$columnHighlig;
  const $ = _c(11);
  const {
    children,
    requiredTableProps,
    zebraStripe: t1,
    frozenOffsets,
    condensed: t2,
    dataDensity
  } = t0;
  const zebraStripe = t1 === undefined ? false : t1;
  const condensed = t2 === undefined ? true : t2;
  const callToAction = useColumnCallToAction();
  let t3;
  if ($[0] !== callToAction) {
    t3 = callToAction ? getColumnCallToActionStyles(callToAction.type) : null;
    $[0] = callToAction;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const styles = t3;
  const t4 = (_callToAction$columnI = callToAction === null || callToAction === void 0 ? void 0 : callToAction.columnIndex) !== null && _callToAction$columnI !== void 0 ? _callToAction$columnI : null;
  const t5 = (_styles$columnHighlig = styles === null || styles === void 0 ? void 0 : styles.columnHighlightColor) !== null && _styles$columnHighlig !== void 0 ? _styles$columnHighlig : null;
  let t6;
  if ($[2] !== children || $[3] !== condensed || $[4] !== dataDensity || $[5] !== frozenOffsets || $[6] !== requiredTableProps || $[7] !== t4 || $[8] !== t5 || $[9] !== zebraStripe) {
    t6 = /*#__PURE__*/_jsx(StyledTable, Object.assign({
      bordered: true,
      condensed: condensed,
      dataDensity: dataDensity,
      flush: true,
      responsive: false
    }, requiredTableProps, {
      zebraStripe: zebraStripe,
      frozenOffsets: frozenOffsets,
      callToActionColumnIndex: t4,
      callToActionHighlightColor: t5,
      children: children
    }));
    $[2] = children;
    $[3] = condensed;
    $[4] = dataDensity;
    $[5] = frozenOffsets;
    $[6] = requiredTableProps;
    $[7] = t4;
    $[8] = t5;
    $[9] = zebraStripe;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};